var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bg"},[_c('div',{staticClass:"btn"},[_c('div',{on:{"click":_vm.jumpTodtail}},[_vm._v("开")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }